export enum images {
  // @ts-ignore
  nothing = `${process.env.STATIC_RES_DOMAIN}/project-custom/react-pc/empty-nothing.png`,
  // @ts-ignore
  notFound = `${process.env.STATIC_RES_DOMAIN}/project-custom/react-pc/empty-404.png`,
  // @ts-ignore
  fail = `${process.env.STATIC_RES_DOMAIN}/project-custom/react-pc/empty-fail.png`,
  // @ts-ignore
  maintain = `${process.env.STATIC_RES_DOMAIN}/project-custom/react-pc/empty-maintain.png`,
  // @ts-ignore
  search = `${process.env.STATIC_RES_DOMAIN}/project-custom/react-pc/empty-search.png`,
  // @ts-ignore
  permissions = `${process.env.STATIC_RES_DOMAIN}/project-custom/react-pc/empty-permissions.png`
};

export enum texts {
  nothing = '暂无内容',
  notFound = '404',
  fail = '暂无信号',
  maintain = '暂无设置',
  search = '暂无结果',
  permissions = '暂无权限',
};
